// https://vuex.vuejs.org/en/getters.html
import i18n from '@/i18n'
import store from '@/store'

export default {
  // todo: Remove this, this should not be necessary once the api is working
  getProductName: (state) => productUid => {
    var product = state.list.find(p => {
      return p.uid === productUid
    })
    return !product ? i18n.t('General.Labels.UnknownEntity', ['product']) : product.displayName
  },
  getProduct: state => productUid => {
    var product = state.list.find(p => {
      return p.uid === productUid
    })
    if (!product) {
      product = state.deletedList.find(p => {
        return p.uid === productUid
      })
    }
    return product
  },
  getProductByVariantId: state => productVariantId => {
    var product = state.list.find(p => {
      return p.variants && p.variants.some(v => v.uid === productVariantId)
    })
    if (!product) {
      var productVariantLink = state.variantDeletedList.find(l => {
        return l.uid === productVariantId
      })
      if (productVariantLink) {
        product = store.getters.getProduct(productVariantLink.productUid)
      }
    }
    return product
  },
  getProductNameByVariantId: state => productVariantId => {
    var product = store.getters.getProductByVariantId(productVariantId)
    return !product ? i18n.t('General.Labels.UnknownEntity', ['product']) : product.displayName
  },
  getProductVariantNameByVariantId: state => productVariantId => {
    var product = state.list.find(p => {
      return p.variants.find(v => v.uid === productVariantId)
    })
    if (product) {
      var variant = product.variants.find(v => v.uid === productVariantId)
      return !variant ? i18n.t('General.Labels.UnknownEntity', ['variant']) : variant.name
    }
    return i18n.t('General.Labels.UnknownEntity', ['variant'])
  },
  getProductVariantSkuByVariantId: state => productVariantId => {
    var product = state.list.find(p => {
      return p.variants.find(v => v.uid === productVariantId)
    })
    if (product) {
      var variant = product.variants.find(v => v.uid === productVariantId)
      return !variant ? i18n.t('General.Labels.UnknownEntity', ['variant']) : variant.externalSku
    }
    return i18n.t('General.Labels.UnknownEntity', ['variant'])
  },
  getProductType: (state) => productUid => {
    var product = state.list.find(p => {
      return p.uid === productUid
    })
    return !product ? i18n.t('General.Labels.UnknownEntity', ['product']) : product.type
  },
  getProductTypeByVariantId: state => productVariantId => {
    var product = state.list.find(p => {
      return p.variants && p.variants.some(v => v.uid === productVariantId)
    })
    if (!product) {
      return i18n.t('General.Labels.UnknownEntity', ['product'])
    }
    var variant = product.variants.find(v => v.uid === productVariantId)
    return !variant ? i18n.t('General.Labels.UnknownEntity', ['variant']) : variant.name
  },
}
